import React from "react";
import { t } from "ttag";

export const TodaysHours = () => <p>{t`Call for Hours`}</p>;
